import { render, staticRenderFns } from "./UsersManagment.vue?vue&type=template&id=1cc44e11&scoped=true&lang=pug&"
import script from "./UsersManagment.vue?vue&type=script&lang=ts&"
export * from "./UsersManagment.vue?vue&type=script&lang=ts&"
import style0 from "./UsersManagment.vue?vue&type=style&index=0&id=1cc44e11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc44e11",
  null
  
)

export default component.exports